export type FuhrparkDetailTab = 'overview' | 'maintenance' | 'docs' | 'repairs' | 'fuel';

const DETAIL_TABS: FuhrparkDetailTab[] = ['overview', 'maintenance', 'docs', 'repairs', 'fuel'];

const instancePrefix = (instanceId?: string): string => {
  if (instanceId) return `/i/${encodeURIComponent(instanceId)}`;
  if (typeof window === 'undefined') return '';
  const match = window.location.pathname.match(/^\/i\/[^/]+/);
  return match ? match[0] : '';
};

export function isFuhrparkDetailTab(value: string | undefined): value is FuhrparkDetailTab {
  return DETAIL_TABS.includes(value as FuhrparkDetailTab);
}

export function fuhrparkListPath(instanceId?: string): string {
  return `${instancePrefix(instanceId)}/fleet`;
}

export function fuhrparkVehiclePath(
  instanceId: string | undefined,
  vehicleId: string,
  tab: FuhrparkDetailTab = 'overview',
): string {
  return `${instancePrefix(instanceId)}/fleet/${encodeURIComponent(vehicleId)}/${tab}`;
}
